import { Shark } from "shark-mvc";
import NousCoreModel from "./NousCoreModel";

class Volume extends NousCoreModel {
	contentCount = 0;
	description = "";
	extraData = {};
	internalNote = "";
	noteForCustomers = "";
	number = 0;
	originalFileURL = "";
	referenceCollections = [];
	subtitle = "";
	title = "";

	__numberLabel = "";
	__statusLabel = "";
	
	constructor (data) {
		super();

		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = super.export();

		exportData.extraData = this.exportObjectField("extraData");
		exportData.referenceCollections = this.exportArrayField("referenceCollections");
		
		return exportData;
	}

	import (data) {
		super.import(data);

		this.importNumberField("contentCount", data.contentCount);
		this.importNumberField("number", data.number);

		if (this.number) {
			this.__numberLabel = this.number.toString().padStart(2, "0");
		}

		switch (this.status) {
			case 1:
				this.__statusLabel = "Da processare";
				this.__statusCSSClass = "bg-danger";
				break;
			case 2:
				this.__statusLabel = "In lavorazione";
				this.__statusCSSClass = "bg-warning";
				break;
			case 3:
				this.__statusLabel = "Inserimento completato";
				this.__statusCSSClass = "bg-success";
				break;
			case 4:
				this.__statusLabel = "Da revisionare";
				this.__statusCSSClass = "bg-warning-subtle text-dark";
				break;
		}
	}
}

Shark.registerModel("Volume", Volume);

export default Volume;